<template>
  <v-img :src="streetViewPhoto" class="fullheight" max-height="300" style="border-radius: 5px;"></v-img>
</template>

<script>
export default {
  computed: {
    streetViewPhoto: function() {
      return "https://maps.googleapis.com/maps/api/streetview?size=400x400&fov=45&key=AIzaSyBeG41-k-Yb9ke_Mzol_LiBYNvn62ZzBVg&source=outdoor&location=" + this.location()
    },
  },

  methods: {
    location: function () {
      return encodeURI([this.match.address1, this.match.city, this.match.state, this.match.zip].join(","))
    },
  },

  props: ['match']
}
</script>
